import { render, staticRenderFns } from "./BaideDeCarnaval.vue?vue&type=template&id=068d7ebd&scoped=true"
import script from "./BaideDeCarnaval.vue?vue&type=script&lang=js"
export * from "./BaideDeCarnaval.vue?vue&type=script&lang=js"
import style0 from "./BaideDeCarnaval.vue?vue&type=style&index=0&id=068d7ebd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068d7ebd",
  null
  
)

export default component.exports